import React, { Component } from "react";
import DataTable from "react-data-table-component";
// import DataTableExtensions from 'react-data-table-component-extensions';
import "react-data-table-component-extensions/dist/index.css";
import {
    getScenarioGroupInfoCloseLoopInstanceDetail,
    editScenarioGroupCloseLoopInstanceDetail,
    selectAllScenarioGroups,
} from "../../components/UserFunctions";
import { Button, Modal, ModalHeader, ModalFooter, ModalBody } from "reactstrap";
import DeleteCloseLoopScenarioGroupModal from "./DeleteCloseLoopScenarioGroupModal";
import {
    addScenarioGroupFromAPI,
    updateScenarioGroupInfo,
} from "../../actions/closeLoop/scenarioGroupActionCloseLoop";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import PopupModal from "../PopupModal";
import Pagination from "./../Pagination";
import { Link } from "react-router-dom";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Alert } from "react-bootstrap";

import CADCart from "../../components/closedLoop/CADCartComponent";
import {
    addScenarioToCart,
    updateShoppingCart,
} from "../../actions/closeLoop/CADaddToCartActionCloseLoop";
import CADPopup from "../../components/closedLoop/AddCADPopup";
import { selectAllScenarioGroupInfo } from "../../actions/closeLoop/scenarioGroup/closeLoopScenarioGroupAction";
import FilterComponent from "../../components/closedLoop/filterComponent";
import ExpandableScenarioComponent from "../../components/closedLoop/scenarioGroup/expandableScenarioComponent";

class CloseLoopScenarioGroupDataTable extends Component {
    constructor(props) {
        super(props);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleEditModalClose = this.handleEditModalClose.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleDeleteModalClose = this.handleDeleteModalClose.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePopUpClose = this.handlePopUpClose.bind(this);
        this.handleAddOperation = this.handleAddOperation.bind(this);
        this.openPopupModal = this.openPopupModal.bind(this);
        this.togglePopup = this.togglePopup.bind(this);
        this.toggleLoading = this.toggleLoading.bind(this);
        this.filteredItem = [];

        this.state = {
            editSelectedRow: undefined,
            deleteSelectedRow: undefined,
            instance_details: "",
            value: "",
            editedSelection: "",
            scn_group_id: "",
            pushStatusPopUp: "",
            editOperation: "",
            scenario_group_count: 0,
            error: "",
            paginationError: "",
            selectAllGroups: false,
            filterText: "",
            scenario_popup: false,
            currentRow: null,
        };
    }

    togglePopup() {
        this.setState({
            scenario_popup: false,
        });
    }

    toggleLoading() {
        this.setState({
            loading: !this.state.loading,
        });
    }

    openPopupModal() {
        this.setState({
            scenario_popup: !this.state.scenario_popup,
        });
    }

    componentDidMount() {
        // document.getElementsByClassName('print')[0].style.visibility = 'hidden';
        // document.getElementsByClassName('download')[0].style.visibility = 'hidden';
        console.log(this.state.filterText, "enter");
        getScenarioGroupInfoCloseLoopInstanceDetail()
            .then((res) => {
                console.log("res-->", res);
                this.setState(() => {
                    return {
                        paginationError: "",
                    };
                });
                if (res.data) {
                    this.props.dispatch(addScenarioGroupFromAPI(res));
                } else {
                    this.props.dispatch(
                        addScenarioGroupFromAPI({ data: [], current_page: 0, pages: [] })
                    );
                }
            })
            .catch((error) => {
                this.setState(() => {
                    return {
                        paginationError: error.response.data.message,
                    };
                });
            });

        selectAllScenarioGroups().then((response) => {
            if (response) {
                this.setState(() => {
                    return {
                        totalGroup: response.number_of_groups,
                        totalGroupList: response.scenario_group_list,
                    };
                });
                this.props.dispatch(selectAllScenarioGroupInfo(response));
            }
        });
    }

    handleChange(event) {
        this.setState({ value: event.target.value });
    }

    handleSubmit(event) {
        event.preventDefault();
        const payload = {
            scenario_group_instance_info: this.state.row_details,
            new_instance_detail: this.state.value,
        };
        editScenarioGroupCloseLoopInstanceDetail(
            "edit_scenario_groups_close_loop_instance_details",
            payload
        )
            .then((res) => {
                if (res.data) {
                    console.log("Response:", res);
                    this.props.scenarioGroupData[
                        this.state.editedSelection
                    ].scenario_group_updated_at = res.data.total_data[0].updated_at;
                    this.props.scenarioGroupData[
                        this.state.editedSelection
                    ].scenario_instance_details = res.data.total_data[0].instance_detail;
                    this.handleEditModalClose();
                    this.setState({
                        pushStatusPopUp: 1,
                        editOperation: `The instance details of scenario group: '${this.state.row_details.scenario_group_name}' have been edited.`,
                        error: "",
                    });
                }
            })
            .catch((error) => {
                this.setState(() => {
                    return {
                        error: error.response.data.message,
                    };
                });
            });
    }

    handleAddOperation = (e) => {
        let buttonValue = e.target.innerHTML;
        let newElement = [];
        newElement.push(e.target.id);
        if (buttonValue === "Add To CAD") {
            // console.log( e.target.id)
            // this.setState({ scenario_group_count:this.state.scenario_group_count+1 });
            const obj = {
                count: this.props.count,
                items: { scenario_group_name: e.target.id },
            };
            this.props.dispatch(addScenarioToCart(obj));
        } else {
            const prev_data = this.props.items;
            console.log(prev_data);

            const [removed_Item] = this.props.items.filter(
                (element) => element.scenario_group_name === e.target.id
            );
            console.log("****************************", removed_Item);

            const new_data = prev_data.filter(
                (element) => element.scenario_group_name !== removed_Item["scenario_group_name"]
            );

            console.log("new set :", new_data);

            const obj = {
                count: this.props.count - 1,
                items: new_data,
            };

            this.props.dispatch(updateShoppingCart(obj));
        }
        console.log("this.props.count", this.props.count);
    };

    handleReset() {
        const payload = this.props.scenarioGroupData[this.state.editedSelection];
        editScenarioGroupCloseLoopInstanceDetail(
            "/reset_scenario_groups_close_loop_instance_details",
            payload
        )
            .then((res) => {
                if (res.data) {
                    this.props.scenarioGroupData[
                        this.state.editedSelection
                    ].scenario_group_updated_at = res.data.total_data[0].updated_at;
                    this.props.scenarioGroupData[
                        this.state.editedSelection
                    ].scenario_instance_details = res.data.total_data[0].instance_detail;
                    this.handleEditModalClose();
                    this.setState({
                        pushStatusPopUp: 1,
                        editOperation: `The instance details of scenario group: '${
                            this.props.scenarioGroupData[this.state.editedSelection]
                                .scenario_group_name
                        }' have been reset.`,
                        error: "",
                    });
                }
            })
            .catch((error) => {
                this.setState(() => {
                    return {
                        error: error.response.data.message,
                    };
                });
            });
    }

    handlePopUpClose() {
        this.setState((prevState) => {
            return {
                ...prevState,
                pushStatusPopUp: undefined,
                editOperation: undefined,
            };
        });
    }

    handleEdit(row) {
        var count = 0;
        var index = undefined;
        this.props.scenarioGroupData.forEach((currElement, index_value) => {
            if (currElement.scenario_group_id === row.scenario_group_id) {
                index = index_value;
                count = count + 1;
            }
        });
        this.setState({
            editedSelection: index,
            value: this.props.scenarioGroupData[index].scenario_instance_details,
            row_details: row,
        });
        this.setState((prevState) => {
            return {
                editSelectedRow: index.toString(),
                deleteSelectedRow: prevState.deleteSelectedRow,
            };
        });
    }
    handleDelete(row) {
        var count = 0;
        var index = undefined;
        this.props.scenarioGroupData.forEach((currElement, index_value) => {
            if (currElement.scenario_group_id === row.scenario_group_id) {
                index = index_value;
                count = count + 1;
            }
        });
        this.setState((prevState) => {
            return {
                editSelectedRow: prevState.editSelectedRow,
                deleteSelectedRow: index.toString(),
            };
        });
    }

    handleEditModalClose() {
        this.setState((prevState) => {
            return {
                editSelectedRow: undefined,
                deleteSelectedRow: prevState.deleteSelectedRow,
                error: "",
            };
        });
    }

    handleDeleteModalClose() {
        this.setState((prevState) => {
            return {
                editSelectedRow: prevState.editSelectedRow,
                deleteSelectedRow: undefined,
            };
        });
    }

    onSelectAllGroups(e) {
        let buttonValue = e.target.innerHTML;

        if (buttonValue === "Select all groups") {
            // selectedPage.push(this.props.currentPage);
            let groupList = [];
            groupList = this.props.totalGroupList;
            console.log(groupList, "totalGroupList data");
            console.log(this.props.items, "scenario group items");
            //            if(this.state.filterText){
            //                let filteredItemList = this.filteredItem;
            //                Object.keys(filteredItemList).map(function (item){
            //                        groupList.push(filteredItemList[item]["scenario_group_name"])
            //                })
            //            }else{
            //                groupList = this.props.totalGroupList;
            //            }

            //            if(this.props.items){
            //                Object.keys(this.props.items).map(key=>{
            //                    groupList.push(this.props.items[key]["scenario_group_name"])
            //                })
            //            }
            let totalGroup = groupList.length;
            let groupNameList = [];
            groupList.forEach(function (item) {
                groupNameList.push({ scenario_group_name: item });
            });
            const obj = {
                count: totalGroup,
                items: groupNameList,
            };
            this.props.dispatch(updateShoppingCart(obj));
            this.setState(() => {
                return {
                    selectAllGroups: true,
                };
            });
        } else {
            const obj = {
                count: 0,
                items: [],
            };
            this.props.dispatch(updateShoppingCart(obj));
            this.setState(() => {
                return {
                    selectAllGroups: false,
                };
            });
        }
    }

    render() {
        console.log("this.state.scenario_popup", this.state.scenario_popup);
        console.log("this.state.loading", this.state.loading); 
        console.log("this.props --->", this.props);
        const customStyles = {
            rows: {
                style: {
                    minHeight: "72px",
                    backgroundColor: "#C7C9FF",
                },
            },
            headCells: {
                style: {
                    fontSize: "1rem",
                    backgroundColor: "white",
                    padding: ".75rem",
                    verticalAlign: "top",
                    borderTop: "1px solid #e9ecef",
                    borderBottom: "5px solid #753DFF",
                    justifyContent: "center",
                },
            },
            cells: {
                style: {
                    fontSize: "1rem",
                    textAlign: "center",
                    verticalAlign: "top",
                    borderTop: "5px solid white",
                    justifyContent: "center",
                },
            },
        };

        const customExpandableStyles = {
            rows: {
                style: {
                    minHeight: "72px",
                },
            },
            headCells: {
                style: {
                    fontSize: "1rem",
                    backgroundColor: "white",
                    padding: ".75rem",
                    verticalAlign: "top",
                    borderTop: "1px solid #e9ecef",
                    borderBottom: "3px solid #753DFF",
                    justifyContent: "center",
                },
            },
            cells: {
                style: {
                    // fontSize: "1rem",
                    textAlign: "center",
                    verticalAlign: "top",
                    borderTop: "5px solid white",
                    justifyContent: "center",
                },
            },
        };

        const columns = [
            {
                name: "Scenario Group Name",
                selector: "scenario_group_name",
                sortable: true,
                cell: (row) => <div style={{ flexWrap: "wrap" }}>{row.scenario_group_name}</div>,
            },
            {
                name: "Group ID",
                selector: "scenario_group_id",
                sortable: true,
                cell: (row) => (
                    <div style={{ alignContent: "center" }}>{row.scenario_group_id}</div>
                ),
            },
            {
                name: "Updated At",
                selector: "scenario_group_updated_at",
                sortable: true,
            },
            {
                name: "Action",
                sortable: false,
                cell: (row) => (
                    <div data-tag="allowRowEvents">
                        <tr className="table-row">
                            <button
                                className="btn"
                                style={{ marginLeft: "1px" }}
                                onClick={() => {
                                    this.handleEdit(row);
                                }}
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Edit"
                            >
                                <i className="fas fa-edit"></i>
                            </button>
                            <button
                                className="btn"
                                style={{ marginLeft: "20px" }}
                                onClick={() => {
                                    this.handleDelete(row);
                                }}
                                data-toggle="tooltip"
                                data-placement="top"
                                title="Delete"
                            >
                                <i className="fas fa-trash"></i>
                            </button>
                        </tr>
                    </div>
                ),
            },
            {
                name: "Scenario Group Selection",
                selector: "scenario_group",
                cell: (row) => (
                    <div style={{ alignContent: "center" }}>
                        <button
                            type="submit"
                            className="btn"
                            id={row.scenario_group_name}
                            style={{
                                backgroundColor: "#4812cc",
                                fontSize: "0.8rem",
                                marginLeft: "20px",
                            }}
                            onClick={(e) => {
                                this.handleAddOperation(e);
                            }}
                        >
                            {this.props.items.some(
                                (obj) => obj.scenario_group_name === row.scenario_group_name
                            )
                                ? "Remove From CAD"
                                : "Add To CAD"}
                        </button>
                    </div>
                ),
            },
        ];
        const scn_columns = [
            {
                name: "Scenario Name",
                selector: "scenario_name",
                sortable: true,
                cell: (row) => <div>{row.scenario_name}</div>,
            },
            {
                name: "Scenario Description",
                selector: "scenario_description",
                sortable: true,
                cell: (row) => (
                    <div style={{ alignContent: "center" }}>{row.scenario_description}</div>
                ),
                grow: 3,
            },
            {
                name: "Scenario UUID",
                selector: "scenario_uuid",
                sortable: true,
                cell: (row) => <div style={{ alignContent: "center" }}>{row.scenario_uuid}</div>,
            },
            {
                name: "Scenario ID",
                selector: "scenario_id",
                sortable: true,
                cell: (row) => <div style={{ alignContent: "center" }}>{row.scenario_id}</div>,
            },
            {
                name: "Group ID",
                selector: "scenario_group_id",
                sortable: true,
                cell: (row) => (
                    <div style={{ alignContent: "center" }}>{row.scenario_group_id}</div>
                ),
            },
        ];
        const getSubHeaderComponent = () => {
            return (
                <FilterComponent
                    onFilter={(e) => {
                        let newFilterText = e.target.value;
                        //                            this.filteredItem = this.props.scenarioGroupData.filter(
                        //                                    item =>
                        //                                      JSON.stringify(item)
                        //                                        .toLowerCase()
                        //                                        .indexOf(newFilterText.toLowerCase()) !== -1
                        //                            );
                        if (newFilterText == "") {
                            let dataToSend = {
                                scenario_group_prefix_name: "",
                            };
                            getScenarioGroupInfoCloseLoopInstanceDetail(1, dataToSend)
                                .then((res) => {
                                    console.log("res-->", res);
                                    this.setState(() => {
                                        return {
                                            paginationError: "",
                                        };
                                    });
                                    if (res.data) {
                                        this.props.dispatch(addScenarioGroupFromAPI(res));
                                    } else {
                                        this.props.dispatch(
                                            addScenarioGroupFromAPI({
                                                data: [],
                                                current_page: 0,
                                                pages: [],
                                            })
                                        );
                                    }
                                })
                                .catch((error) => {
                                    this.setState(() => {
                                        return {
                                            paginationError: error.response.data.message,
                                        };
                                    });
                                });
                            selectAllScenarioGroups(dataToSend).then((response) => {
                                if (response) {
                                    console.log("............", response.number_of_groups);
                                    console.log("............", response.scenario_group_list);
                                    this.setState(() => {
                                        return {
                                            totalGroup: response.number_of_groups,
                                            totalGroupList: response.scenario_group_list,
                                        };
                                    });
                                    this.props.dispatch(selectAllScenarioGroupInfo(response));
                                }
                            });
                        }
                        this.setState({ filterText: newFilterText });
                    }}
                    onFilterValue={(e) => {
                        let dataToSend = {
                            scenario_group_prefix_name: this.state.filterText,
                        };
                        getScenarioGroupInfoCloseLoopInstanceDetail(1, dataToSend)
                            .then((res) => {
                                this.setState(() => {
                                    return {
                                        paginationError: "",
                                    };
                                });
                                if (res.data) {
                                    this.props.dispatch(addScenarioGroupFromAPI(res));
                                } else {
                                    this.props.dispatch(
                                        addScenarioGroupFromAPI({
                                            data: [],
                                            current_page: 0,
                                            pages: [],
                                        })
                                    );
                                }
                            })
                            .catch((error) => {
                                this.setState(() => {
                                    return {
                                        paginationError: error.response.data.message,
                                    };
                                });
                            });
                        selectAllScenarioGroups(dataToSend).then((response) => {
                            if (response) {
                                console.log("............", response.number_of_groups);
                                console.log("............", response.scenario_group_list);
                                this.setState(() => {
                                    return {
                                        totalGroup: response.number_of_groups,
                                        totalGroupList: response.scenario_group_list,
                                    };
                                });
                                this.props.dispatch(selectAllScenarioGroupInfo(response));
                            }
                        });
                    }}
                    filterText={this.state.filterText}
                />
            );
        };
        //        let data= []
        //        if(this.state.filterText){
        //             data = this.filteredItem
        //        }else{
        //            console.log(this.props.scenarioGroupData, "scenario group data")
        const data = this.props.scenarioGroupData;
        //        }
        // const scn_list = data.scenario_list
        // const scn_data = {
        //   scn_columns,
        //   scn_list
        // }
        console.log("DATAAA:", data);
        const ExpandableComponent = ({ data }) => (
            <ExpandableScenarioComponent scenarioId={data.scenario_group_id} />
        );

        return (
            <div className="container-fluid">
                <Breadcrumb>
                    <Breadcrumb.Item href="">
                        <Link to="navigate_new">Home</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="">
                        <Link to="/welcome">Welcome</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="">
                        {" "}
                        <Link to="/close_loop">Close loop</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item href="/close_loop_scenario_group" active>
                        Scenario Group View
                    </Breadcrumb.Item>
                </Breadcrumb>
                <div className="row ">
                    <div className="col mt-5 mx-auto">
                        <div className="card" style={{ backgroundColor: "white" }}>
                            <div className="card">
                                <div>
                                    <div style={{ backgroundColor: "#757AF7" }}>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <h3
                                                    className="card-header"
                                                    style={{
                                                        color: "white",
                                                        fontSize: "100% !important",
                                                        backgroundColor: "#757AF7",
                                                    }}
                                                >
                                                    Scenario Group View
                                                </h3>
                                            </div>
                                            <div
                                                className="col-md-6"
                                                style={{ paddingLeft: "24rem", paddingTop: "1%" }}
                                            >
                                                <div style={{ textAlign: "center" }}>
                                                    <button
                                                        onClick={this.openPopupModal}
                                                        style={{
                                                            backgroundColor: "Transparent",
                                                            outline: "None",
                                                            border: "None",
                                                            float: "right",
                                                        }}
                                                    >
                                                        <CADCart />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="table col-md-6 mx-auto"> */}
                            {Object.keys(data).length === 0 ? undefined : (
                                <div style={{ textAlign: "right" }}>
                                    <button
                                        style={{
                                            backgroundColor: "#757AF7",
                                            // fontSize: "0.8rem",
                                            margin: "0.5rem 0.5rem 0 0.5rem",
                                            fontWeight: "bold",
                                            color: "#FFFFFF",
                                            border: "0rem",
                                            borderRadius: "0.2rem",
                                            padding: "0.5rem",
                                        }}
                                        onClick={(e) => this.onSelectAllGroups(e)}
                                    >
                                        {this.state.selectAllGroups === true
                                            ? "Deselect all groups"
                                            : "Select all groups"}
                                    </button>
                                    {/* <button
                                        style={{
                                            backgroundColor: "#757AF7",
                                            // fontSize: "0.8rem",
                                            margin: "0.5rem 0.5rem 0 0.5rem",
                                            fontWeight: "bold",
                                            color: "#FFFFFF",
                                            border: "0rem",
                                            borderRadius: "0.2rem",
                                            padding: "0.5rem",
                                        }}
                                        onClick={(e) => this.onSelectAllGroupPerPage(e)}
                                    >
                                        {this.state.selectAllGroupPerPageFlag === true
                                            ? "Deselect all groups per page"
                                            : "select all groups per page"}
                                    </button> */}
                                </div>
                            )}
                            <div className="table">
                                <div className="card-body">
                                    {/* <DataTableExtensions
                                     {...tableData}> */}
                                    <DataTable
                                        className="dataTables_wrapper"
                                        columns={columns}
                                        customStyles={customStyles}
                                        data={data}
                                        defaultSortField="id"
                                        defaultSortAsc={false}
                                        //pagination
                                        expandableRows
                                        setFilter
                                        expandableRowExpanded={(row) => (row === this.state.currentRow)}
                                        expandOnRowClicked
                                        expandableRowsComponent={<ExpandableComponent />}
                                        onRowClicked={(row) => this.setState({currentRow: row})}
                                        onRowExpandToggled={(bool, row) => this.setState({currentRow: row})}
                                        subHeader
                                        subHeaderComponent={getSubHeaderComponent()}
                                    ></DataTable>
                                    {/* </DataTableExtensions> */}
                                </div>
                            </div>
                        </div>
                        {this.state.scenario_popup ? (
                            <CADPopup
                                closePopup={this.togglePopup.bind(this)}
                                useHistory={this.props}
                                loading={this.toggleLoading.bind(this)}
                            />
                        ) : undefined}
                        {this.state.editSelectedRow !== undefined ? (
                            <Modal
                                isOpen={this.state.editSelectedRow >= 0}
                                editSelectedRow={this.state.editSelectedRow}
                            >
                                <ModalHeader
                                    toggle={this.handleEditModalClose}
                                    style={{ color: "#753DFF" }}
                                >
                                    Edit Instance Details
                                </ModalHeader>
                                <ModalBody>
                                    {this.state.error ? (
                                        <Alert key="danger" variant="danger">
                                            {this.state.error}
                                        </Alert>
                                    ) : undefined}
                                    <form onSubmit={this.handleSubmit}>
                                        <div className="form-group">
                                            <label>
                                                Edit Instance Details:
                                                <textarea
                                                    rows="15"
                                                    cols="45"
                                                    type="text"
                                                    value={this.state.value}
                                                    onChange={this.handleChange}
                                                />
                                            </label>
                                            <input
                                                className="btn"
                                                style={{
                                                    marginLeft: "30%",
                                                    backgroundColor: "#E3E3E3",
                                                }}
                                                type="submit"
                                                value="Submit"
                                            />
                                            <Button
                                                className="btn"
                                                style={{ marginLeft: "1%", backgroundColor: "red", color:"#FFFFFF"}}
                                                onClick={() => {
                                                    this.handleReset();
                                                }}
                                            >
                                                Reset
                                            </Button>
                                        </div>
                                    </form>
                                </ModalBody>
                                <ModalFooter>
                                    <Button
                                        className="btn"
                                        style={{ backgroundColor: "#753DFF" }}
                                        onClick={this.handleEditModalClose}
                                    >
                                        Close
                                    </Button>
                                </ModalFooter>
                            </Modal>
                        ) : undefined}
                        {this.state.pushStatusPopUp ? (
                            <PopupModal
                                heading="Confirmation"
                                text={this.state.editOperation}
                                closePopup={this.handlePopUpClose}
                            />
                        ) : undefined}
                        <div>
                            {this.state.paginationError ? (
                                <Alert key="danger" variant="danger">
                                    {this.state.paginationError}
                                </Alert>
                            ) : undefined}
                            {this.props.scenarioGroupData.length > 0 ? (
                                <Pagination
                                    currentPage={this.props.currentPage}
                                    pages={this.props.pages}
                                    filterValue={this.state.filterText}
                                    getApiInfo={getScenarioGroupInfoCloseLoopInstanceDetail}
                                    action={addScenarioGroupFromAPI}
                                />
                            ) : undefined}
                        </div>
                        {this.state.deleteSelectedRow ? (
                            <DeleteCloseLoopScenarioGroupModal
                                deleteSelectedRow={this.state.deleteSelectedRow}
                                handleDeleteModalClose={this.handleDeleteModalClose}
                                content={
                                    this.props.scenarioGroupData[
                                        parseInt(this.state.deleteSelectedRow)
                                    ]
                                }
                            />
                        ) : undefined}
                    </div>
                </div>
            </div>
        );
    }
}
CloseLoopScenarioGroupDataTable.propTypes = {
    dispatch: PropTypes.func,
    scenarioGroupData: PropTypes.array,
    currentPage: PropTypes.number,
    pages: PropTypes.array,
    allScenarioGroupData: PropTypes.array,
};
CloseLoopScenarioGroupDataTable.defaultProps = {
    scenarioGroupData: [],
    currentPage: 0,
    pages: [],
    allScenarioGroupData: [],
};

const mapStateToProps = (state) => {
    return {
        scenarioGroupData: state.close_loop_scenarioGroup.scenarioGroup,
        currentPage: state.close_loop_scenarioGroup.currentPage,
        pages: state.close_loop_scenarioGroup.pages,
        count: state.CAD_close_loop_cart.count,
        items: state.CAD_close_loop_cart.items,
        totalGroup: state.selectAllScenarioGroupInfo.totalGroup,
        totalGroupList: state.selectAllScenarioGroupInfo.totalGroupList,
        allScenarioGroupData: state.close_loop_scenarioGroup.allScenarioGroup,
    };
};
export default connect(mapStateToProps)(CloseLoopScenarioGroupDataTable);
